var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRejected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4545",
    "data-name": "Group 4545",
    transform: "translate(-432 -887.996)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1042",
    "data-name": "Ellipse 1042",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(432 887.996)",
    fill: "#fc3838"
  }), /*#__PURE__*/React.createElement("g", {
    id: "x-circle-fill",
    transform: "translate(454.446 909.695)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2326",
    "data-name": "Rectangle 2326",
    width: 28,
    height: 28,
    transform: "translate(-0.446 0.301)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10470",
    "data-name": "Path 10470",
    d: "M35.419,24A11.419,11.419,0,1,0,46.837,35.419,11.419,11.419,0,0,0,35.419,24Zm4.134,14.311a.878.878,0,1,1-1.242,1.242l-2.892-2.892-2.892,2.892a.878.878,0,1,1-1.242-1.242l2.892-2.892-2.892-2.892a.878.878,0,1,1,1.242-1.242l2.892,2.892,2.892-2.892a.878.878,0,0,1,1.242,1.242l-2.892,2.892Z",
    transform: "translate(-21.864 -21.118)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.c687b636d30bffd9cd71b289ce48b6df.svg";
export { ForwardRef as ReactComponent };